export const employee = "employee";
export const vendor = "vendor";
export const customer = "customer";
export const product = "product";
export const salesOrder = "salesOrder";
export const purchaseOrder = "purchaseOrder";
export const returnOrder = "returnOrder";
export const expense = "expense";